import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import ThemeVariables from "./ThemeVariables";
import { QueryClient, QueryClientProvider } from "react-query";
import ErrorBoundary from "./components/ErrorBoundary";
import { ColorThemeProvider } from "./contexts/ThemeContext";
import MuiThemeBridge from "./MuiThemeBridge";

// Sane query defaults: a short staleTime so remounts/tab-refocus don't refire
// every GET, and no refetch-on-focus by default (individual queries can still
// opt back in). Keeps the model/profile lists from refetching on every focus.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ColorThemeProvider>
            <MuiThemeBridge>
              <ThemeVariables>
                <App />
              </ThemeVariables>
            </MuiThemeBridge>
          </ColorThemeProvider>
        </QueryClientProvider>
      </Provider>
    </HelmetProvider>
  </ErrorBoundary>
);
